/* eslint-disable */
/* tslint:disable */

import {
	AssignedCategoryInfo,
	CategorizationResponse,
	FstekExportArchiveCreateRequest,
	FstekExportedOkiiLocationInfo,
	FstekExportedOkiiResponse,
	FstekExportOkiiResponse,
	KIIDocxTableViewParamsRequest,
	KIIDocxTableViewTopResponse,
	OKIIEnumsSimpleResponse,
	OKIIExportBundleInfo,
	String,
	TopTableLevelRow,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

class ObjectsKii<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
	/**
	 * @description threatModelObjectExists : false // серый элемент, не кликабельно; threatModelObjectExists : true // синий элемент, кликабельно; categoryAssigned : true // зеленый элемент, кликабельно (повторный выбор)
	 *
	 * @tags Oбъекты КИИ
	 * @summary Получение списка объектов КИИ
	 * @request GET:/objects_kii/{org_id}/list
	 * @secure
	 */
	listDetail = (
		orgId: number,
		query?: {
			/**
			 * номер страницы (1)
			 * @format int32
			 */
			page?: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/** имя объекта */
			obj_name?: string;
			/** индекс статуса объекта */
			status_filter?: string;
			/** индекс тип объекта */
			obj_type_filter?: string;
			/** индекс типа активности */
			activity_type_filter?: string;
			/** индекс типа подтвержденности группы документов */
			docs_approval_type_filter?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<OKIIEnumsSimpleResponse[], void>({
			path: `/objects_kii/${orgId}/list`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Oбъекты КИИ
	 * @summary Список ОКИИ на отправку в ФСТЭК
	 * @request GET:/objects_kii/{org_id}/export/list
	 * @secure
	 */
	exportListDetail = (
		orgId: number,
		query: {
			/**
			 * id партии отправленных документов (0 для любой)
			 * @format int64
			 */
			bundle_id?: number;
			/**
			 * количество элементов
			 * @format int32
			 */
			num?: number;
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/** сортировка */
			sort?: string;
			/** строка поиска */
			query?: string;
			/** только подлежащие включению в партию */
			exportable?: boolean;
		},
		params: RequestParams = {},
	) =>
		this.request<FstekExportOkiiResponse, void>({
			path: `/objects_kii/${orgId}/export/list`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Oбъекты КИИ
	 * @summary Список партий документов ОКИИ, отправленных в ФСТЭК
	 * @request GET:/objects_kii/{org_id}/export/bundle/list
	 * @secure
	 */
	exportBundleListDetail = (
		orgId: number,
		query?: {
			/**
			 * количество элементов
			 * @format int32
			 */
			num?: number;
			/**
			 * ID последней партии из предыдущего запроса (для пагинации)
			 * @format int64
			 */
			lastid?: number;
		},
		params: RequestParams = {},
	) =>
		this.request<OKIIExportBundleInfo[], void>({
			path: `/objects_kii/${orgId}/export/bundle/list`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Oбъекты КИИ
	 * @summary Получить архив для партии документов ОКИИ
	 * @request GET:/objects_kii/{org_id}/export/bundle
	 * @secure
	 */
	exportBundleDetail = (
		orgId: number,
		query: {
			/**
			 * id партии документов ОКИИ
			 * @format int64
			 */
			bundle_id: number;
		},
		params: RequestParams = {},
	) =>
		this.request<String, void>({
			path: `/objects_kii/${orgId}/export/bundle`,
			method: "GET",
			query: query,
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Oбъекты КИИ
	 * @summary Сформировать архив для партии документов ОКИИ
	 * @request POST:/objects_kii/{org_id}/export/bundle
	 * @secure
	 */
	exportBundleCreate = (orgId: number, data: FstekExportArchiveCreateRequest, params: RequestParams = {}) =>
		this.request<OKIIExportBundleInfo, void>({
			path: `/objects_kii/${orgId}/export/bundle`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Oбъекты КИИ
	 * @summary Список ОКИИ для присвоения номера ФСТЭК
	 * @request GET:/objects_kii/{org_id}/exported/list
	 * @secure
	 */
	exportedListDetail = (
		orgId: number,
		query: {
			/**
			 * количество элементов
			 * @format int32
			 */
			num?: number;
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/** строка поиска */
			query?: string;
			/**
			 * предзагрузить сведения по адресам объекта
			 * @format int32
			 */
			preload_locations?: number;
			/** только подлежащие прикреплению письма */
			exportable?: boolean;
		},
		params: RequestParams = {},
	) =>
		this.request<FstekExportedOkiiResponse, void>({
			path: `/objects_kii/${orgId}/exported/list`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Oбъекты КИИ
	 * @summary Список сведений об адресах ОКИИ для присвоения номера ФСТЭК
	 * @request GET:/objects_kii/{org_id}/exported/{object_id}/locations/list
	 * @secure
	 */
	exportedLocationsListDetail = (
		orgId: number,
		objectId: number,
		query: {
			/**
			 * количество элементов
			 * @format int32
			 */
			num?: number;
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<FstekExportedOkiiLocationInfo[], void>({
			path: `/objects_kii/${orgId}/exported/${objectId}/locations/list`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Oбъекты КИИ
	 * @summary Получить письмо ФСТЕК
	 * @request GET:/objects_kii/{org_id}/exported/letter
	 * @secure
	 */
	exportedLetterDetail = (
		orgId: number,
		query: {
			/** ссылка на документ */
			key: string;
			/** имя документа */
			name: string;
		},
		params: RequestParams = {},
	) =>
		this.request<File, void>({
			path: `/objects_kii/${orgId}/exported/letter`,
			method: "GET",
			query: query,
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Oбъекты КИИ
	 * @summary Загрузить письмо ФСТЕК для выбранных ОКИИ
	 * @request POST:/objects_kii/{org_id}/exported/letter
	 * @secure
	 */
	exportedLetterCreate = (
		orgId: number,
		data: {
			/** @format binary */
			file?: File;
			idlist?: FstekExportArchiveCreateRequest;
		},
		params: RequestParams = {},
	) =>
		this.request<FstekExportedOkiiResponse, void>({
			path: `/objects_kii/${orgId}/exported/letter`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.FormData,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Oбъекты КИИ
	 * @summary Изменить реестровый номер ФСТЭК и итоговую категорию ОКИИ
	 * @request PUT:/objects_kii/{org_id}/exported/{okii_id}
	 * @secure
	 */
	exportedUpdate = (
		orgId: number,
		okiiId: number,
		query?: {
			/** новый реестровый номер */
			registryId?: string;
			/**
			 * новая категория ОКИИ
			 * @format int32
			 */
			category?: number;
		},
		params: RequestParams = {},
	) =>
		this.request<FstekExportedOkiiResponse, void>({
			path: `/objects_kii/${orgId}/exported/${okiiId}`,
			method: "PUT",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Oбъекты КИИ
	 * @summary Изменить реестровый номер ФСТЭК для адреса размещения объекта
	 * @request PUT:/objects_kii/{org_id}/exported/{okii_id}/locations/{location_id}
	 * @secure
	 */
	exportedLocationsUpdate = (
		orgId: number,
		okiiId: number,
		locationId: number,
		query: {
			/** новый реестровый номер */
			registryId: string;
		},
		params: RequestParams = {},
	) =>
		this.request<FstekExportedOkiiLocationInfo, void>({
			path: `/objects_kii/${orgId}/exported/${okiiId}/locations/${locationId}`,
			method: "PUT",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Oбъекты КИИ
	 * @summary Зафиксировать действие над объектом
	 * @request GET:/objects_kii/{org_id}/exported/{okii_id}/touch
	 * @secure
	 */
	exportedTouchDetail = (
		orgId: number,
		okiiId: number,
		query: {
			/** действие (READ, DOWNLOAD) */
			action: string;
		},
		params: RequestParams = {},
	) =>
		this.request<void, void>({
			path: `/objects_kii/${orgId}/exported/${okiiId}/touch`,
			method: "GET",
			query: query,
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Oбъекты КИИ
	 * @summary Получение данных выбранного объекта
	 * @request GET:/objects_kii/{obj_id}/categorising
	 * @secure
	 */
	categorisingDetail = (objId: number, params: RequestParams = {}) =>
		this.request<TopTableLevelRow[], void>({
			path: `/objects_kii/${objId}/categorising`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Oбъекты КИИ
	 * @summary Отправка данных после категоризации
	 * @request POST:/objects_kii/{obj_id}/categorising
	 * @secure
	 */
	categorisingCreate = (objId: number, data: CategorizationResponse[], params: RequestParams = {}) =>
		this.request<AssignedCategoryInfo, void>({
			path: `/objects_kii/${objId}/categorising`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Oбъекты КИИ
	 * @summary Просмотр документов после присвоения категории
	 * @request POST:/objects_kii/{org_id}/doc_review
	 * @secure
	 */
	docReviewCreate = (orgId: number, data: KIIDocxTableViewParamsRequest, params: RequestParams = {}) =>
		this.request<KIIDocxTableViewTopResponse[], void>({
			path: `/objects_kii/${orgId}/doc_review`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Oбъекты КИИ
	 * @summary Получение документа по его id
	 * @request GET:/objects_kii/docs/{doc_id}/{format}
	 * @secure
	 */
	docsDetail = (docId: number, format?: string, params: RequestParams = {}) =>
		this.request<File, void>({
			path: `/objects_kii/docs/${docId}/${format}`,
			method: "GET",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Oбъекты КИИ
	 * @summary Получение PDF ссылки документа по его id
	 * @request GET:/objects_kii/docs/{doc_id}/link
	 * @secure
	 */
	docsLinkDetail = (docId: number, params: RequestParams = {}) =>
		this.request<String, void>({
			path: `/objects_kii/docs/${docId}/link`,
			method: "GET",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Oбъекты КИИ
	 * @summary Выгрузка утвержденных документов
	 * @request POST:/objects_kii/docs/{doc_id}/upload
	 * @secure
	 */
	docsUploadCreate = (
		docId: number,
		data: {
			/** @format binary */
			ApprovedDoc?: File;
		},
		params: RequestParams = {},
	) =>
		this.request<KIIDocxTableViewTopResponse[], void>({
			path: `/objects_kii/docs/${docId}/upload`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.FormData,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Oбъекты КИИ
	 * @summary Удаление документов этой локации по ID ВЫБРАННОГО ДОКУМЕНТА
	 * @request DELETE:/objects_kii/docs/{doc_id}/deleteGroup
	 * @secure
	 */
	docsDeleteGroupDelete = (docId: number, params: RequestParams = {}) =>
		this.request<KIIDocxTableViewTopResponse[], void>({
			path: `/objects_kii/docs/${docId}/deleteGroup`,
			method: "DELETE",
			secure: true,
			format: "json",
			...params,
		});
}
export const objectsKiiAPI = new ObjectsKii();
